/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Utils */
import { ClassNames } from '../../../../utils/misc';

/* Styles */
import './ConditionalVisible.scss';

const ConditionalVisibleClassNames = ClassNames.component('conditional-visible');

function ConditionalVisible({ className, children, visible }) {
  return (
    <div className={ConditionalVisibleClassNames.block({ visible }, className)}>
      {children}
    </div>
  );
}

ConditionalVisible.propTypes = {
  className: PropTypes.string,
  visible: PropTypes.bool,
  children: PropTypes.node,
};

ConditionalVisible.defaultProps = {
  className: '',
  visible: false,
  children: undefined,
};

export default memo(ConditionalVisible);
